import { paidByLabel, whatsappLabel } from "./guestFormat";
import { isNotComing } from "./notComing";
import {
  partyMemberLabel,
  partyTags,
  sourceLabel,
  type PartyMember,
  type RosterRow,
} from "./shared";

/** The party in one spreadsheet cell: "Asha (64, F): Senior; Ava (6)". */
function partyCell(party: readonly PartyMember[]): string {
  return party
    .map((m) => {
      const tags = partyTags(m);
      return tags.length > 0
        ? `${partyMemberLabel(m)}: ${tags.join(", ")}`
        : partyMemberLabel(m);
    })
    .join("; ");
}

/**
 * The guest list download's columns. Event week: the existing columns
 * keep their names, order and values (people print this and sort it);
 * new columns only go on the end.
 */
export const GUEST_LIST_HEADER = [
  "Event",
  "Reference",
  "Name",
  "Email",
  "Phone",
  "Heard via",
  "Dietary requirements",
  "Booking",
  "Amount",
  "Adults",
  "Children",
  "Total",
  "Registered",
  "Reminder sent",
  "Party",
  "Group",
  "Note",
  "Paid by",
  "WhatsApp group",
  "Checked in at",
  "Not coming",
  "Who told them",
];

/** One registration as a row under GUEST_LIST_HEADER. */
export function guestListRow(r: RosterRow): (string | number)[] {
  return [
    r.eventTitle,
    r.confirmationRef,
    r.name,
    r.email,
    r.phone ?? "",
    sourceLabel(r.heardAboutUs),
    r.dietaryRequirements ?? "",
    r.bookingType ?? "",
    r.paidAmountCents != null ? (r.paidAmountCents / 100).toFixed(2) : "",
    r.adults,
    r.children,
    r.totalPeople,
    r.createdAt,
    r.reminderSentAt ?? "",
    partyCell(r.party),
    r.groupName ?? "",
    r.registrantNote ?? "",
    paidByLabel(r) ?? "",
    whatsappLabel(r) ?? "",
    r.checkedInAt ?? "",
    isNotComing(r) ? "Yes" : "",
    r.heardAboutUsDetail ?? "",
  ];
}
